import { AlertTriangle, Settings2 } from 'lucide-react';

import { useRecordingStore } from '@/entities/audio-recording';
import { SelectMic } from '@/features/audio/select-mic';
import { PopoverTooltipButton } from '@/shared/ui/common/popover-tooltip-button';

import { useSilenceWarning } from '../../../model/use-silence-warning';

export function RecordingCaptureSettings() {
    const isSilent = useRecordingStore((state) => state.isSilent);
    const { isWarningShown, hideWarning } = useSilenceWarning(isSilent);

    return (
        <div className="relative">
            <PopoverTooltipButton
                tooltipProps={{ open: isWarningShown }}
                hideTooltipWhenOpen={false}
                tooltipContent={
                    <span>
                        <b className="font-semibold">We're not hearing any audio</b>
                        <b className="font-medium">.</b> Check your microphone settings
                    </span>
                }
                tooltipContentProps={{
                    side: 'bottom',
                    alignOffset: 1,
                    className: 'w-[23rem]',
                    showClose: true,
                    onClose: hideWarning,
                }}
                popoverContent={<SelectMic />}
                popoverContentProps={{
                    className: 'w-auto p-4',
                    side: 'bottom',
                    align: 'start',
                    alignOffset: 1,
                }}
                buttonProps={{
                    variant: 'outline',
                    size: 'icon',
                    'aria-label': 'Audio Settings',
                    className: 'size-10',
                    onClick: hideWarning,
                }}
            >
                <Settings2 className="h-4 w-4" />
                {isSilent && (
                    <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2">
                        <AlertTriangle className="h-4 w-4 text-yellow-600 fill-yellow-400" />
                    </div>
                )}
            </PopoverTooltipButton>
        </div>
    );
}
